module.exports = __webpack_public_path__ + "img/jelicic.cfd845d2.jpg";